import { UseFormReturn } from 'react-hook-form'
import { z } from 'zod'

import { marketType } from '@/gen/publicApi'

import FormComplexRadio from '@/components/form/formComplexRadio'

// eslint-disable-next-line react-refresh/only-export-components
export const typeSchema = z.object({
    type: z.nativeEnum(marketType),
})

type TypeSchemaType = z.infer<typeof typeSchema>

interface Props {
    form: UseFormReturn<TypeSchemaType>
}

export default function CreateMarketTypeForm({ form }: Props) {
    return (
        <FormComplexRadio
            control={form.control}
            name="type"
            options={[
                {
                    value: marketType.Persistent,
                    label: 'Persistent',
                    description: 'Opens and closes at a set time with custom timing events',
                },
                {
                    value: marketType.Ephemeral,
                    label: 'Ephemeral',
                    description: 'Always open. Timing events can be controlled via the API',
                },
            ]}
        />
    )
}
